import qs from 'querystring'
import moment from 'moment';
import { actionTypes as requestsActionTypes } from './requests'
import checkAuthorizationError from '../../utils/checkAuthorizationError';
import parseRequestError from '../../utils/parseRequestError';
//import { LOGIN_AUTH_TOKEN } from '../../config';

export const actionTypes = {
    SET_USER: 'SET_USER',
    LOGOUT: 'LOGOUT'
}

const setUser = (user) => async (dispatch, getState, api) => {
    await dispatch({
        type: actionTypes.SET_USER,
        payload: user
    })

}

export const startApp = (params) => async (dispatch, getState, api) => {
    let logout = params

    if (!logout) {
        localStorage.removeItem('logout')
    }
}

export const setAccessToken = (token) => async (dispatch, getState, api) => {
    let result = {}
    try {
        await dispatch({
            type: requestsActionTypes.REQUEST_LOGIN,
            payload: {
                loading: true,
            }
        })

        dispatch(setUser({
            accessToken: token,
            expires: null,
            type: 'bearer'
        }));
        result = {
            success: true,
            data: token
        }
    } catch (e) {
        checkAuthorizationError(e, dispatch)
        result = parseRequestError(e)
    }

    dispatch({
        type: requestsActionTypes.REQUEST_LOGIN,
        payload: {
            success: true
        }
    })
    return result;
}

export const login = ({ storeId, user, pass }) => async (dispatch, getState, api) => {
    let result = {}
    try {
        await dispatch({
            type: requestsActionTypes.REQUEST_LOGIN,
            payload: {
                loading: true,
            }
        })
        const url = `${api.defaults.baseURL.replace(/\/+$/, '')}/oauth/login` ;
        const apiResponse = await api.post(url, qs.stringify({
            estabelecimentoid: storeId,
            username: user,
            password: pass,
            grant_type: 'password'
        }), {
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            //    "Authorization": LOGIN_AUTH_TOKEN
            }
        });
        const response = apiResponse.data;
        dispatch(setUser({
            accessToken: response.access_token,
            expires: moment().add(response.expires_in, 'seconds').toISOString(),
            type: response.token_type
        }));
        result = {
            success: true,
            data: response
        }
    } catch (e) {
        checkAuthorizationError(e, dispatch)
        result = parseRequestError(e)
    }
    dispatch({
        type: requestsActionTypes.REQUEST_LOGIN,
        payload: {
            success: true
        }
    })
    return result;
}

export const logout = (multistore) => async (dispatch, getState, api) => {
    cleanLocalstorage();
    dispatch(setUser(null));
    dispatch({
        type: actionTypes.LOGOUT,
    })
}

const cleanLocalstorage = () => {
    localStorage.setItem('logout', JSON.stringify(true));
    setTimeout(() => {
        localStorage.clear('multistore', false);
        localStorage.clear('multistore:selectedStore');
        localStorage.clear('multistore:stores');
    }, 500);
}
